import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';
import { Loader } from '@googlemaps/js-api-loader';

const SECTION_ID = 'connect-page-section-c';
const MAP_CONTAINER_CLASS = 'locations';
const MAP_CLASS = 'map';

class GoogleMap {
    constructor() {
        this._section = document.getElementById(SECTION_ID);
        this._section && this._run();
    }
    _run() {
        this._mapContainer = this._section.querySelector(`.${MAP_CONTAINER_CLASS}`);
        this._maps = this._section.querySelectorAll(`.${MAP_CLASS}`);

        this._runMapLoader();
        this._loader.load().then(() => {
            this._createMap();
        });
    }
    _runMapLoader() {
        this._loader = new Loader({
            apiKey: this._mapContainer.dataset.key,
            version: 'weekly',
            libraries: ['places', 'geometry', 'marker'],
            language: 'en',
        });
    }
    _createMap() {
        this._maps.forEach((element) => {
            // const styledMapType = new google.maps.StyledMapType(
            //     [
            //         {
            //             featureType: 'all',
            //             elementType: 'all',
            //             stylers: [
            //                 {
            //                     visibility: 'on',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'all',
            //             elementType: 'geometry.fill',
            //             stylers: [
            //                 {
            //                     color: '#282828',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'administrative',
            //             elementType: 'labels.text.fill',
            //             stylers: [
            //                 {
            //                     color: '#ffffff',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'administrative',
            //             elementType: 'labels.text.stroke',
            //             stylers: [
            //                 {
            //                     color: '#282828',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'landscape',
            //             elementType: 'all',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'landscape.natural.landcover',
            //             elementType: 'geometry.fill',
            //             stylers: [
            //                 {
            //                     visibility: 'on',
            //                 },
            //                 {
            //                     color: '#282828',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'landscape.natural.terrain',
            //             elementType: 'geometry.fill',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //                 {
            //                     color: '#282828',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'poi',
            //             elementType: 'all',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'poi',
            //             elementType: 'geometry',
            //             stylers: [
            //                 {
            //                     visibility: 'on',
            //                 },
            //                 {
            //                     color: '#4b4a4a',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'poi',
            //             elementType: 'labels',
            //             stylers: [
            //                 {
            //                     visibility: 'on',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'poi',
            //             elementType: 'labels.text',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'poi.attraction',
            //             elementType: 'labels',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'poi.business',
            //             elementType: 'labels',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'poi.government',
            //             elementType: 'labels',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'poi.medical',
            //             elementType: 'labels',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'poi.park',
            //             elementType: 'labels',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'poi.place_of_worship',
            //             elementType: 'labels',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'poi.school',
            //             elementType: 'labels',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'poi.sports_complex',
            //             elementType: 'labels',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road',
            //             elementType: 'geometry.fill',
            //             stylers: [
            //                 {
            //                     visibility: 'on',
            //                 },
            //                 {
            //                     color: '#ec7773',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road',
            //             elementType: 'labels',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.highway',
            //             elementType: 'geometry',
            //             stylers: [
            //                 {
            //                     visibility: 'on',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.highway',
            //             elementType: 'geometry.stroke',
            //             stylers: [
            //                 {
            //                     visibility: 'on',
            //                 },
            //                 {
            //                     color: '#ec7773',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.highway',
            //             elementType: 'labels.text',
            //             stylers: [
            //                 {
            //                     visibility: 'on',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.highway',
            //             elementType: 'labels.icon',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.highway.controlled_access',
            //             elementType: 'geometry',
            //             stylers: [
            //                 {
            //                     visibility: 'on',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.highway.controlled_access',
            //             elementType: 'geometry.fill',
            //             stylers: [
            //                 {
            //                     visibility: 'on',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.highway.controlled_access',
            //             elementType: 'geometry.stroke',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.arterial',
            //             elementType: 'geometry',
            //             stylers: [
            //                 {
            //                     visibility: 'on',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.arterial',
            //             elementType: 'geometry.stroke',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.arterial',
            //             elementType: 'labels',
            //             stylers: [
            //                 {
            //                     visibility: 'on',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.arterial',
            //             elementType: 'labels.text.fill',
            //             stylers: [
            //                 {
            //                     color: '#ffffff',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.arterial',
            //             elementType: 'labels.text.stroke',
            //             stylers: [
            //                 {
            //                     color: '#282828',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.local',
            //             elementType: 'geometry',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.local',
            //             elementType: 'geometry.fill',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'road.local',
            //             elementType: 'labels',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'transit',
            //             elementType: 'all',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'water',
            //             elementType: 'all',
            //             stylers: [
            //                 {
            //                     visibility: 'simplified',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'water',
            //             elementType: 'geometry',
            //             stylers: [
            //                 {
            //                     color: '#727272',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'water',
            //             elementType: 'labels',
            //             stylers: [
            //                 {
            //                     color: '#000000',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'water',
            //             elementType: 'labels.text.fill',
            //             stylers: [
            //                 {
            //                     visibility: 'on',
            //                 },
            //             ],
            //         },
            //         {
            //             featureType: 'water',
            //             elementType: 'labels.text.stroke',
            //             stylers: [
            //                 {
            //                     visibility: 'off',
            //                 },
            //             ],
            //         },
            //     ],
            //     { name: 'Styled Map' },
            // );

            const opts = {
                center: {
                    lat: parseFloat(element.dataset.lat),
                    lng: parseFloat(element.dataset.lng),
                },
                zoom: innerWidth >= screenSm ? parseFloat(element.dataset.zoomDesktop) : parseFloat(element.dataset.zoomMobile),
                mapId: this._mapContainer.dataset.id,
                maxZoom: 20,
                minZoom: 0,
                mapTypeId: 'roadmap',
                clickableIcons: false,
                disableDoubleClickZoom: true,
                draggable: false,
                keyboardShortcuts: false,
                scrollwheel: false,
            };

            const setControlOptions = (key, enabled, position, style, mapTypeIds) => {
                opts[key + 'Control'] = enabled;
                opts[key + 'ControlOptions'] = {
                    position: google.maps.ControlPosition[position],
                    style: google.maps.MapTypeControlStyle[style],
                    mapTypeIds: mapTypeIds,
                };
            };

            setControlOptions('fullscreen', false, 'DEFAULT', '', null);
            setControlOptions('mapType', false, 'DEFAULT', 'DEFAULT', ['roadmap', 'satellite', 'terrain']);
            setControlOptions('rotate', false, 'DEFAULT', '', null);
            setControlOptions('scale', false, '', '', null);
            setControlOptions('streetView', false, 'DEFAULT', '', null);
            setControlOptions('zoom', false, 'DEFAULT', '', null);

            const map = new google.maps.Map(element, opts);

            (() => {
                const markerOptions = {
                    map: map,
                    position: {
                        lat: parseFloat(element.dataset.lat),
                        lng: parseFloat(element.dataset.lng),
                    },
                    content: document.createElement('div'),
                };

                const markerElement = markerOptions.content;
                markerElement.style.width = innerWidth >= screenSm ? '5.0625rem' : '3.125rem';
                markerElement.style.height = innerWidth >= screenSm ? '5.0625rem' : '3.125rem';
                markerElement.style.position = 'relative';
                markerElement.style.top = innerWidth >= screenSm ? '2.53125rem' : '1.5625rem';
                markerElement.style.left = 0;
                markerElement.style.backgroundImage = `url(${this._mapContainer.dataset.marker})`;
                markerElement.style.backgroundSize = 'contain';
                markerElement.style.backgroundRepeat = 'no-repeat';

                new google.maps.marker.AdvancedMarkerElement({
                    ...markerOptions,
                });
            })();

            // map.mapTypes.set('styled_map', styledMapType);
            // map.setMapTypeId('styled_map');
        });
    }
}

const googleMap = new GoogleMap();
